module.exports = __webpack_public_path__ + "assets/powerful-icon.079b15a8.svg";